<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_AzmoonMaharatDetail.id==0">Register New Proficiency Test Stage
      '{{inner_AzmoonMaharat.title}}' </h5>
    <h5 class="card-title" *ngIf="inner_AzmoonMaharatDetail.id>0">Edit Stage '{{inner_AzmoonMaharatDetail.title}}'
    </h5>

    <form [formGroup]="AzmoonMaharatForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_title().valid && get_Form_title().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a title.</small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Start Date </label>
          <input formControlName="startDate" type="text" class="form-control" #startDateInput
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="startDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_startDate().valid && get_Form_startDate().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a start date.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> End Date </label>
          <input formControlName="endDate" type="text" class="form-control" #endDateInput
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="endDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_endDate().valid && get_Form_endDate().touched"
            class="form-text text-muted MyErrorRedColor">Please enter an end date.</small>
        </div>
      </div>


    </form>

    <br />
    <hr />
    <br />

    <form [formGroup]="AzmoonMaharatFileForm">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_FormFile_title().valid && get_FormFile_title().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a title.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> File </label>
          <input #file_template (change)="UploadTemplate(file_template.files)" type="file" class="form-control"
            placeholder="Type here...">
          <small *ngIf="!get_FormFile_templateSrc().valid && get_FormFile_templateSrc().touched"
            class="form-text text-muted MyErrorRedColor">Please select a file.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="button" (click)="OnSubmitFile()" [disabled]="!AzmoonMaharatFileForm.valid"
        class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add File </button>
    </form>

    <br />
    <hr />
    <br />

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>File</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of FileDataLise">
           <td>{{FileDataLise.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                View File
              </a>
            </td>
            <td>
              <button (click)="RemoveFile(FileDataLise.indexOf(item))" type="button" class="btn btn-danger"> Delete </button>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

   <br />
   <hr />
   <br />

   <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
   <button *ngIf="!InProccessing" type="button" (click)="OnSubmit()" [disabled]="!AzmoonMaharatForm.valid"
     class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
   <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>



  </div>
</div>
